import React from 'react';
import Form from '../../../misc/form/form';
import Button from '../../../ui/button/button';
import { classnames } from '../../../../../utils/classnames';
import AttendeeCard from '../../../cards/attendeeCard/attendeeCard';
import useForm from '../../../../../utils/useForm';
import { generate_use_form_schema } from '../../../../../steps/formStep';
import { useTranslation } from 'react-i18next';
import './attendeeForm.css';
import Checkbox from '../../../ui/checkbox/checkbox';
import { iframeScrollTo } from '../../../../../utils/scroll';

export default function AttendeeForm({formBuyer = {},attendee = {}, showMore = [], setShowMore = () => {}, index = "", setAttendees = () => {}, eventCountry = null }) {
    const { t } = useTranslation();

    const { errors: formErrorsAttendeeBackend } = attendee;

    const duplicateBuyerForm = attendee.duplicate_buyer_form;

    const toggleShowMore = React.useCallback(() => {
        setShowMore(previousState => {
            let changed = {};
            changed[index] = !previousState[index];
            return {...previousState, ...changed};
        })
    }, [index]);

    let attendeeSchema = React.useRef(generate_use_form_schema(attendee.fields));

    const [formAttendee, setFormValueAttendee, setFormObject, , formErrors, onValidate, onChangeErrors] = useForm(attendeeSchema.current, {
        validateOnChange: false,
		clearOnChange: true,
		onChange: form => {
            setAttendees(previousState => {
                let newState = {...previousState};
                newState[index].form = form;
                return newState;
            })
        }
	});

    const onDuplicateFormBuyer = React.useCallback((e, {checked}) => {
        if (checked) {
            let attendeeFormKeys = Object.keys(formAttendee);
            let commonBuyerForm = Object.fromEntries(Object.entries(formBuyer).filter(([k, v]) => attendeeFormKeys.includes(k)));
            setFormObject(commonBuyerForm)
        }
    },[formBuyer, formAttendee])

    const onContinue = React.useCallback(() => {
        let { valid } = onValidate();
        if (valid) {
            setShowMore(previousState => {
                let newState = {...previousState};
                newState[index] = false;
                const keyList = Object.keys(previousState);
                const position = keyList.indexOf(index);
                if (position + 1 < keyList.length) {
                    newState[keyList[position + 1]] = true;
                    document.querySelector(`.neo-attendee-card-attendee_${position + 2}`)?.focus();
                } else {
                    document.querySelector(".neo-cgv-container .neo-external-link")?.focus();
                }
                return newState;
            })
            iframeScrollTo(document.querySelector(`.neo-attendee-card-${index}`));
        }
    }, [index, onValidate]);

    //This useEffect allows us to set state in the parent component the validation functions for each attendee,
    //which allows us to trigger validations on global onSubmit of the form step
    React.useEffect(() => {
        setAttendees(previousState => {
            let newState = {...previousState};
            newState[index].onValidate = onValidate;
            return newState;
        })
    },[index, onValidate]);

    React.useEffect(() => {
        if (Object.keys(formErrorsAttendeeBackend).length) {
            onChangeErrors({...formErrorsAttendeeBackend});
        }
    },[formErrorsAttendeeBackend]);

    return (
        <AttendeeCard className={`neo-attendee-card-${index}`} isForm showMore={showMore} index={index} attendee={attendee} formAttendee={formAttendee} toggleShowMore={toggleShowMore} formErrors={formErrors} disabled={!Object.keys(formAttendee).length}>
            <div className={classnames('neo-attendee-form', {'show-more': showMore[index]})}>
                <div className='neo-attendee-form-divider'/>
                {duplicateBuyerForm && <Checkbox uniqueKey={`duplicate_${index}`} onChange={onDuplicateFormBuyer} label={duplicateBuyerForm.label} description={duplicateBuyerForm.description}/>}
                <Form form={formAttendee} formIndex={index} setFormValue={setFormValueAttendee} setFormObject={setFormObject} fields={attendee.fields} formErrors={formErrors} country={eventCountry}/>
                <div className='neo-attendee-form-cta'>
                    <Button type='inverted' label={t('widget.resale.breakdown.cta-confirm')} onClick={onContinue}/>
                </div>
            </div>
        </AttendeeCard>
    )
}
